export const dtCopy = {
  dt_s_page_title: "Cari paket yang mempunyai tipe data",
  dt_s_title: "Cari Tipe Data",
  dt_s_subtitle:
    "Cari paket npm yang mempunyai deklarasi tipe data, yang jadi satu maupun di Definitely Typed.",
  dt_s_match: "cocok",
  dt_s_matchs: "cocok",
  dt_s_match_exact: "Benar-benar Cocok",
  dt_s_popular_on_dt: "Populer di Definitely Typed",
  dt_s_downloads_short: "DLs",
  dt_s_downloads_via: "Melalui",
  dt_s_module: "Modul",
  dt_s_last_update: "Terakhir Diperbarui",
  dt_s_install: "Pasang",
  dt_s_no_results: "Tidak ada hasil ditemukan untuk",
  dt_s_no_results_try: "Coba pencarian lain?",
  dt_s_copy: "salin",
  dt_s_copied: "tersalin",
}
